"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
        onCreate: function() {
          this.state = {
              activeState: false
            };
        },
        onInput: function(input) {
          if (input.state !== undefined) {
            this.state.activeState = input.state === true;
          }
        },
        onClick: function() {
          this.state.activeState = !this.state.activeState;

          this.emit("click");

          this.emit("change", this.state.activeState);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Button/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("span", {
      "class": marko_classValue(marko_classValue([
        "display-inline-block",
        (!input.icon ? "btn " : "cursor-pointer ") + ((!input.activeClass) || (!state.activeState) ? input.class : input.activeClass)
      ])),
      title: input.title,
      style: marko_styleValue(input.style)
    }, "0", component, null, 0, {
      onclick: __component.d("click", "onClick", false)
    });

  if (input.icon) {
    out.e("i", {
        "class": marko_classValue("bx " + ((!input.activeIcon) || (!state.activeState) ? input.icon : input.activeIcon)),
        style: "font:inherit;color:inherit"
      }, "1", component, 0, 1);
  }

  marko_dynamicTag(out, input.renderBody, null, null, null, null, __component, "2");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
